<template>
  <svg
    width="57"
    height="84"
    viewBox="0 0 57 84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40 48H16V81.865C16 82.7128 16.9889 83.176 17.6402 82.6332L28 74L38.3598 82.6332C39.0111 83.176 40 82.7128 40 81.865V48Z"
      fill="#482C1E"
    />
    <path
      d="M30.007 0.806252C28.866 -0.220543 27.1341 -0.220604 25.9932 0.806252L22.9973 3.50254C22.2637 4.16276 21.2524 4.4199 20.2925 4.19035L16.1727 3.20493C14.6226 2.83408 13.053 3.74027 12.5991 5.2681L11.3628 9.42887C11.074 10.401 10.3136 11.1614 9.3415 11.4502L5.70124 12.5318C4.17341 12.9858 3.26722 14.5553 3.63801 16.1054L4.66401 20.3948C4.89991 21.3811 4.62159 22.4197 3.9242 23.1559L1.17127 26.0618C0.0750809 27.2189 0.0750809 29.0312 1.17121 30.1883L4.15656 33.3395C4.85395 34.0757 5.13227 35.1143 4.89637 36.1006L4.01301 39.7937C3.64222 41.3438 4.54841 42.9134 6.07624 43.3673L9.87745 44.4967C10.8496 44.7856 11.6099 45.5459 11.8988 46.518L13.1236 50.6404C13.5776 52.1683 15.1471 53.0744 16.6973 52.7036L20.9189 51.6938C21.9052 51.4579 22.9439 51.7362 23.68 52.4336C25.1066 53.7852 27.1482 55.7193 28.3696 56.8764C28.6873 57.1774 33.2807 52.471 33.8418 51.9394C34.5582 51.2607 35.5628 50.9778 36.5281 51.1827L40.2004 51.9624C41.7019 52.2812 43.2018 51.4153 43.6764 49.9555L44.9738 45.9659C45.2706 45.053 45.9862 44.3374 46.8991 44.0406L50.8887 42.7433C52.3484 42.2687 53.2144 40.7687 52.8956 39.2673L52.0377 35.2265C51.8383 34.2875 52.1002 33.3099 52.7423 32.5965L55.4104 29.6319C56.4373 28.491 56.4373 26.7591 55.4104 25.6181L52.604 22.4999C51.9618 21.7864 51.6999 20.8088 51.8992 19.8699L52.7706 15.766C53.0894 14.2646 52.2234 12.7646 50.7637 12.29L46.3956 10.8696C45.4829 10.5728 44.7672 9.85715 44.4704 8.94437L43.3351 5.45298C42.8605 3.99326 41.3605 3.1273 39.8591 3.44608L35.7553 4.31742C34.8164 4.51676 33.8387 4.25486 33.1253 3.61271L30.007 0.806252Z"
      fill="#F49B24"
    />
    <circle
      cx="28"
      cy="28"
      r="19"
      fill="#FFF9E4"
    />
    <path
      d="M26.9993 17.694C27.2967 16.7687 28.606 16.7687 28.9034 17.694L30.7972 23.5868C30.9301 24.0003 31.3148 24.2808 31.7492 24.2808H37.9008C38.8669 24.2808 39.2714 25.5148 38.4928 26.0867L33.4973 29.7562C33.1506 30.0108 33.0056 30.4586 33.1373 30.8681L35.0409 36.7915C35.3376 37.7147 34.2784 38.4775 33.4969 37.9034L28.5434 34.2648C28.1911 34.0061 27.7116 34.0061 27.3594 34.2648L22.4059 37.9034C21.6243 38.4775 20.5651 37.7147 20.8618 36.7915L22.7655 30.8681C22.8971 30.4586 22.7521 30.0108 22.4054 29.7562L17.4099 26.0867C16.6313 25.5148 17.0359 24.2808 18.0019 24.2808H24.1535C24.5879 24.2808 24.9726 24.0003 25.1055 23.5868L26.9993 17.694Z"
      fill="#F49B24"
    />
    <circle
      cx="28.5"
      cy="63.5"
      r="3.5"
      fill="#C55803"
    />
    <rect
      x="18"
      y="54"
      width="2"
      height="23"
      rx="1"
      fill="#C55803"
    />
    <rect
      x="36"
      y="54"
      width="2"
      height="23"
      rx="1"
      fill="#C55803"
    />
  </svg>
</template>
